import React, { useEffect, useState } from "react";
import DateFilter, { getPresetRange } from "../../components/common/DateFilter";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import { fetchDayWiseStats } from "../../api/questionStats";

const num = (n) => Number(n || 0).toLocaleString("en-IN");

const StatBox = ({ label, value }) => (
  <div className="rounded-xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-gray-900">
    <p className="text-base text-gray-500">{label}</p>
    <p className="mt-2 text-4xl font-bold text-gray-800 dark:text-white">
      {num(value)}
    </p>
  </div>
);

const Analytics = () => {
  const [range, setRange] = useState(getPresetRange("today"));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);

    fetchDayWiseStats(range.from, range.to)
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch(() => {
        // error aave to pan "No data found" batavisu
        if (!cancelled) setData(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [range.from, range.to]);

  const questions = data?.questions || [];
  const total = data?.total || { share: 0, view: 0, send: 0 };
  const hasData = questions.length > 0;

  return (
    <div>
      <PageBreadcrumb pageTitle="Question Analytics" />

      {/* breadcrumbni niche, left side date picker */}
      <div className="mb-6 flex items-center justify-start">
        <DateFilter value={range} onChange={setRange} />
      </div>

      {loading ? (
        <div className="flex min-h-[40vh] items-center justify-center text-base text-gray-500">
          Loading...
        </div>
      ) : !hasData ? (
        <div className="flex min-h-[40vh] items-center justify-center text-base text-gray-500 dark:text-gray-400">
          No data found.
        </div>
      ) : (
        <div className="space-y-8">
          {/* Grand total */}
          <div className="grid gap-4 sm:grid-cols-3">
            <StatBox label="Total Share" value={total.share} />
            <StatBox label="Total View" value={total.view} />
            <StatBox label="Total Send" value={total.send} />
          </div>

          {/* Question wise total */}
          <div>
            <h3 className="mb-4 text-lg font-semibold text-gray-700 dark:text-gray-200">
              Question wise (selected range)
            </h3>

            {/* ek row ma 2 j */}
            <div className="grid gap-4 sm:grid-cols-2">
              {questions.map((q) => (
                <div
                  key={q.categoryId}
                  className="rounded-xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-gray-900"
                  style={{ borderLeft: `6px solid ${q.color}` }}
                >
                  <div className="mb-4 flex items-center gap-3">
                    <span
                      className="inline-block h-4 w-4 rounded-full"
                      style={{ background: q.color }}
                    />
                    <p className="text-base font-semibold text-gray-800 dark:text-white">
                      Que {q.categoryId} · {q.name}
                    </p>
                  </div>

                  <div className="grid grid-cols-3 text-center">
                    <div>
                      <p className="text-sm text-gray-500">Share</p>
                      <p className="text-2xl font-bold" style={{ color: q.color }}>
                        {num(q.share)}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">View</p>
                      <p className="text-2xl font-bold" style={{ color: q.color }}>
                        {num(q.view)}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Send</p>
                      <p className="text-2xl font-bold" style={{ color: q.color }}>
                        {num(q.send)}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Analytics;